import { forwardRef, useState } from 'react'
import { TabsContext } from './tabs-context'
import { v4 as uuid } from 'uuid'
import { StyledTabsRoot } from '../styled-components'
import { tabsActivationModeOptions } from '../constants'
import PropTypes from 'prop-types'

const TabsRoot = forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    onValueChange,
    defaultValue,
    activationMode = tabsActivationModeOptions.AUTOMATIC,
    disabled = false,
    loading = false,
    ...tabsProps
  } = props

  const [componentValue, setComponentValue] = useState(defaultValue)

  const value = valueProp ?? componentValue
  const setValue = onValueChange ?? setComponentValue

  const contextValue = {
    baseId: uuid(),
    value,
    onValueChange: setValue,
    activationMode,
    disabled,
    loading
  }

  return (
    <TabsContext.Provider value={contextValue}>
      <StyledTabsRoot {...tabsProps} ref={forwardedRef} />
    </TabsContext.Provider>
  )
})

TabsRoot.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func,
  defaultValue: PropTypes.string,
  activationMode: PropTypes.oneOf(Object.values(tabsActivationModeOptions)),
  disabled: PropTypes.bool,
  loading: PropTypes.bool
}

TabsRoot.displayName = 'TabsRoot'
export default TabsRoot
